import { SPACE } from '@angular/cdk/keycodes';
import {Component, OnInit, Input, ViewChild, ElementRef, Self, Optional, Output, EventEmitter} from '@angular/core';
import {NgControl} from '@angular/forms';
import {ComparableOperator, PosibleAnswer} from 'app/models/form';
import { BehaviorSubject } from 'rxjs';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent extends BaseAnswerTypeComponent<number | number[]> implements OnInit {
  @Input() multiple: boolean = false;
  @Input() placeholder: string = '';
  @Input() label: string;

  @Input() filterEnabled: boolean = false;
  @Input() allOptionEnabled: boolean = false;

  @Output('setCommentListRequired') public setCommentListRequired: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('selectFilterInput') selectFilterInput: ElementRef<HTMLInputElement>;
  
  filteredItemsData: PosibleAnswer[] = [];

  _items$: BehaviorSubject<PosibleAnswer[]>;
  get items(): PosibleAnswer[] {
    return this._items$.getValue();
  }
  @Input() set items(value: PosibleAnswer[]) {
    this._items$.next(value);
  }

  constructor(
    @Self()
    @Optional()
    ngControl?: NgControl,
  ) {
    super(ngControl);
    this._items$ = new BehaviorSubject<PosibleAnswer[]>([]);
  }

  ngOnInit() {
    this._items$.subscribe(value => this.filteredItemsData = value);

    if(this.filterEnabled) {
      this.ngControl.valueChanges.subscribe(value => {
        let founded = 0;
        this.filteredItemsData.map(x => {
          if(x.id == value && x.commentsRequired){
            founded++;
          }
        });
        if(founded > 0){
          this.setCommentListRequired.emit(true);
        }else{
          this.setCommentListRequired.emit(false);
        }
        if(!value) {
          this.selectFilterInput.nativeElement.value = '';
          this.filteredItemsData = this.items;
        }
      })
    }
  }

  onFilterSelectKeyUp(event) {
    event.stopPropagation();
    let filter = event.target?.value.toLocaleLowerCase();
    this.filteredItemsData = this.items.filter(item => item.description.toLowerCase().includes(filter));
  }

  onSelectItem(){
    setTimeout(() => {
      this.selectFilterInput.nativeElement.value = '';
      this.filteredItemsData = this.items;
    }, 500);
  }
  /**
   * For this operations SelectInputComponent will not manage multiple selection. For that, use SelectMultipleInputComponent
   */
  AllowedOperators: {[K in ComparableOperator]: (target: number, value: string) => boolean} = {
    [ComparableOperator.Equal]: (t, value: string) => t == Number(value),
    [ComparableOperator.NotEqual]: (t, value) => t != Number(value),
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => value.split(";").map(v => Number(v)).includes(t),
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (t) => !t,
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t,
    [ComparableOperator.Between]: null,
  }

}
